import axios from "../../../../api/axios";
import { Entity } from "../../../../types/types/entity.types";

interface FollowResponse {
  isFollowing: boolean;
}

export const followEntityService = async (entityId: number): Promise<boolean> => {
  try {
    const response = await axios.put<FollowResponse>(`football-entities/${entityId}/follow`);
    return response.data.isFollowing;
  } catch (error) {
    throw new Error(`Failed to follow entity: ${error}`);
  }
};

export const unfollowEntityService = async (entityId: number): Promise<boolean> => {
  try {
    const response = await axios.delete<FollowResponse>(`football-entities/${entityId}/follow`);
    return response.data.isFollowing;
  } catch (error) {
    throw new Error(`Failed to unfollow entity: ${error}`);
  }
};
